import {
	Container,
	Breakpoints,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TextAlignment,
	CTA,
	Spinner,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaVentaValues } from '../../../shared/models/hucha-values';
import { HuchaDisclaimer1Content } from '../disclaimers/hucha-disclaimer1-content';
import { useHuchaPdfGenerator } from '../../../shared/hooks/use-hucha-pdf-generator';
import { PopupHuchaStandardCard } from './popup-card/popup-hucha-standard-card/popup-hucha-standard-card';
import { useHuchaVentaLayerContent } from '../../hooks/use-hucha-venta-layer-content';
import { PdfHuchaContent } from '../../../shared/components/pdf-hucha-content';

export const HuchaStandardVouchersPopup: React.FC<{
	huchaValues: HuchaVentaValues;
}> = ({ huchaValues }) => {
	const targetRefPDF = React.useRef<HTMLDivElement>(null);
	const { handlePdfDownloadClick, isDownloading, isPdfReady } = useHuchaPdfGenerator(huchaValues, targetRefPDF);
	const { huchaVentaPdfLayerContent } = useHuchaVentaLayerContent(huchaValues);

	return (
		<>
			<Container
				padding={{
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b560]: ContainerPadding.grid002,
						[Breakpoints.b960]: ContainerPadding.grid001,
					},
					bottom: ContainerPadding.dynamic0200,
					left: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b560]: ContainerPadding.grid002,
						[Breakpoints.b960]: ContainerPadding.grid001,
					},
				}}
				horizontalAlign={'center'}
				wrap={'always'}
			>
				<PopupHuchaStandardCard dineroHucha={huchaValues?.dineroHucha ?? ''} />
				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
				>
					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						Por formar parte del Club Volkswagen, cada mes acumulas saldo que podrás utilizar para tu próximo
						Volkswagen.
					</Text>
					<Container
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0200,
								[Breakpoints.b560]: ContainerPadding.dynamic0150,
							},
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<CTA
							tag="button"
							aria-label="Descargar ahorro acumulado"
							size="large"
							onClick={handlePdfDownloadClick}
							emphasis="primary"
							disabled={isDownloading}
							stretchContent={{ [Breakpoints.default]: true, [Breakpoints.b560]: false }}
							icon={isDownloading ? <Spinner /> : undefined}
						>
							<Text>{isDownloading ? 'Descargando' : 'Descargar ahorro acumulado'}</Text>
						</CTA>
					</Container>
					<Container
						wrap={'always'}
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0200,
								[Breakpoints.b560]: ContainerPadding.dynamic0150,
							},
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center} bold>
							¿Cómo puedes utilizarlo?
						</Text>
						<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center}>
							Muy sencillo. Si ha llegado el momento de estrenar Volkswagen de nuevo, descárgate aquí tu ahorro
							acumulado y muéstralo en tu punto de venta para poder disfrutarlo.
						</Text>
					</Container>
					<Container
						wrap={'always'}
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0200,
								[Breakpoints.b560]: ContainerPadding.dynamic0150,
							},
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<HuchaDisclaimer1Content />
					</Container>
				</Container>
			</Container>
			{isPdfReady && <PdfHuchaContent targetRef={targetRefPDF} layerContent={() => huchaVentaPdfLayerContent} />}
		</>
	);
};
